import request from "./http";

class PartyRepository
{
    async create(party) {
        const path = "parties/create";
        const method = "POST";
        const data = party;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("create", error);
        }
    }

    async edit(party) {
        const path = "parties/edit";
        const method = "POST";
        const data = party;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("edit", error);
        }
    }

    async remove(party) {
        const path = "parties/remove";
        const method = "POST";
        const data = party;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("edit", error);
        }
    }

    async getOneById(id) {
        const path = "parties/get-party";
        const method = "GET";
        const data = {
            id: id
        };

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get one by id", error);
        }
    }

    async getAll() {
        const path = "parties";
        const method = "GET";
        const data = null;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get all", error);
        }
    }

    async gridview(query) {
        const path = "parties/gridview";
        const method = "POST";
        const data = query;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get all", error);
        }
    }
}

export default PartyRepository;